import Api from '@api/localMerchant/NameCard'
import { getMerchantInfo } from '@util'

export const getNameCardRight = async () => {
  const { success, data } = await Api.cardStatus({
    merchantId: getMerchantInfo().id
  })
  if (success) {
    return data && data.isOn === 1
  } else {
    return false
  }
}

export const establishNameCard = async () => {
  const { success, msg } = await Api.openCard({
    merchant_id: getMerchantInfo().id
  })

  if (success) {
    return 1
  } else {
    return msg
  }
}
